import React from "react";
import dynamic from 'next/dynamic';
import {Card} from "antd";
import style from "./chartSupport.module.scss";
import {useTranslations} from "next-intl";

const Pie = dynamic(() => import('@ant-design/plots').then(({ Pie }) => Pie),
    { ssr: false }
);

export const SupportTotalChart = ({info}) => {
    const t = useTranslations('dashboard');
    const config = {
        data: info && info.info ? info.info : [],
        angleField: 'value',
        colorField: 'type',
        innerRadius: 0.5,
        padding: 50,
        label: {
            text: (d) => `${d.type}\n ${d.value}`,
            position: 'outside',
        },
        legend: false,
        tooltip: false,
        annotations: [
            {
                type: 'text',
                tooltip: false,
                style: {
                    text: `${t('total') + '\n' + info?.total_count ?? 0}` + ' ' + t('tickets'),
                    x: '50%',
                    y: '50%',
                    textAlign: 'center',
                    fontSize: 16,
                    fontStyle: '400',
                },
            },
        ],
        scale: { color: { range: ['#C95F5F', '#9E3636', '#C97474', '#B47C7C', '#9A5151'] } },
        height: 365,
    };

    return (
        <>
            <div className={style.block}><Card
                title={t('support_ticket')}
                className={'charts'}
            >
                <Pie {...config} />
            </Card>
            </div>
        </>
    );
}